import { keepPreviousData, queryOptions, useQuery } from "@tanstack/react-query"
import { GET } from "@/api/client"
import type { SanctionsScreeningParams } from "@/api/types"

export const companySanctionsKey = (companyId: number) =>
	["companies", companyId, "kyc", "sanctions"] as const

export function companySanctionsOptions(
	companyId: number,
	params: SanctionsScreeningParams = {},
) {
	return queryOptions({
		queryKey: [...companySanctionsKey(companyId), params] as const,
		queryFn: () =>
			GET("/api/v1/companies/{company_id}/kyc/sanctions", {
				params: {
					path: { company_id: companyId },
					query: params,
				},
			}),
		enabled: companyId > 0,
		placeholderData: keepPreviousData,
	})
}

export function useCompanySanctions(
	companyId: number,
	params: SanctionsScreeningParams = {},
) {
	return useQuery(companySanctionsOptions(companyId, params))
}
